import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { CLICK_NEXT, UNSAVED_CHANGES_DISPLAYED } from '../analytics.constants';
import { getEcgTimeStartedSelector } from '../selectors/analytics-info.selectors';

export const trackEcg =
  (
    name: typeof CLICK_NEXT | typeof UNSAVED_CHANGES_DISPLAYED,
    analyticsTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const startTime = getEcgTimeStartedSelector(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    const timeSpent = DateTime.now().toMillis() - startTime;

    analyticsTrack({
      name,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        time_spent: timeSpent,
      },
    });
  };
